module.exports = __webpack_public_path__ + "img/go-top-hover.13b43919.png";